export const addHostnameUrlParam = (url, paramName = 'merchantDomain') => {
  const newUrl = new URL(url);
  if (typeof window !== 'undefined') {
    newUrl.searchParams.append(paramName, window.location.hostname);
  }
  return newUrl.toString();
};
